












































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import Role from '@/store/entities/role';
@Component
export default class CreateRole extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    role:Role=new Role();
    userPermissions: any = []
    get permissions(){
        return this.$store.state.role.permissions
    }
    defaultProps = {
        children: 'children',
        label: 'label'
    }
    created(){
        this.getpermissions()
    }
    save(){
        (this.$refs.roleForm as any).validate(async (valid:boolean)=>{
            if(valid){

                let nodes = (this.$refs.tree as any).getCheckedNodes()
                let permissions = nodes.map((item:any)=>{
                    return item.id
                })
                this.role.permissions=permissions
                await this.$store.dispatch({
                    type:'role/create',
                    data:this.role
                });
                (this.$refs.roleForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input',false);
            }
        })
    }
    cancel(){
        (this.$refs.roleForm as any).resetFields();
        this.$emit('input',false);
    }
    permissionData:any = [
        {
            label:'所有',
            id: "all",
            children:[]
        }
    ]
    async getpermissions(){
        let data = await this.$store.dispatch({
            type:'role/getPermissions'
        })
        if(data){
            data.forEach((item,index) => {
                this.permissionData[0].children.push({
                    label:item.displayName,
                    id:item.name,
                    children:[]
                })
                item.children.forEach(item_c => {
                    this.permissionData[0].children[index].children.push({
                        label:item_c.displayName,
                        id:item_c.name,

                    })
                });
            });
        }
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
    roleRule={
        name:[{required: true,message:this.L('FieldIsRequired',undefined,this.L('RoleName')),trigger: 'blur'}],
        displayName:[{required:true,message:this.L('FieldIsRequired',undefined,this.L('DisplayName')),trigger: 'blur'}]
    }
}
